import axios from 'axios';

export default {
  createPaymentIntent(data = {}) {
    return axios.post(`${process.env.VUE_APP_NEW_API_URL}/staff/payment-intent`, data);
  },
};
